import useYoutubeVideoLinkData from "hook/useYoutubeVideoLinkData";
import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { FaPlay, FaTimes } from "react-icons/fa";
import { createPortal } from "react-dom";
import { ShimmerYoutubePreview } from "components/shimmer/ShimmerYoutubePreview";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import SectionHeader from "../commonComponent/SectionHeader";
const VideoModal = ({ url, onClose, isShort }) => {
  if (!url) return null;

  const getYoutubeId = (url = "") => {
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    );
    return match ? match[1] : null;
  };

  const id = getYoutubeId(url);
  const embedUrl = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;

  return createPortal(
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/80"
      onClick={onClose}
    >
      {/* Modal Box */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative bg-black rounded-xl overflow-hidden shadow-2xl
        ${
          isShort
            ? "w-[360px] h-[640px] sm:w-[420px] sm:h-[740px]"
            : "w-[92%] max-w-6xl"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 bg-white text-black w-10 h-10 rounded-full flex items-center justify-center shadow-lg hover:bg-red-500 hover:text-white transition"
        >
          <FaTimes />
        </button>

        {/* Player */}
        {isShort ? (
          <iframe
            src={embedUrl}
            title="YouTube Video Player"
            className="w-full h-full"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        ) : (
          <div className="relative w-full pt-[56.25%]">
            <iframe
              src={embedUrl}
              title="YouTube Video Player"
              className="absolute inset-0 w-full h-full"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </div>,
    document.body, // ⬅️ THIS IS THE IMPORTANT PART
  );
};

const YoutubePreview = () => {
  const { theme, language } = useSettings();
  const isDark = theme === "dark";
  const { links, loadingLink } = useYoutubeVideoLinkData();
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    if (activeVideo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [activeVideo]);

  const getYoutubeId = (url = "") => {
    if (!url) return null;

    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    );

    return match ? match[1] : null;
  };

  const getEmbedUrl = (url) => {
    const id = getYoutubeId(url);
    return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : "";
  };

  const isYoutubeShort = (url = "") => /youtube\.com\/shorts\//.test(url);

  if (loadingLink) {
    return <ShimmerYoutubePreview />;
  }

  return (
    <section className="relative md:max-w-7xl mx-auto sm:px-4 2xl:px-0 lg:px-8 md:pb-4 pb-0">
      <div className={`${isDark?"bg-gray-100":"bg-white"} px-4 pb-5 rounded`}>
        {links.length > 0 ? (
            <div className="flex justify-between items-center md:pt-5 pt-3 md:pb-5 pb-3">
            <SectionHeader title={t("watchOurProducts", language)} />
            </div>
        ) : null}
        <div className="relative flex snap-x gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {links.map((video) => {
            const videoId = getYoutubeId(video.link);
            const thumbnail = videoId
              ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
              : "/no-video.png"; // optional fallback
            return (
              <button
                key={video.id}
                type="button"
                onClick={() => setActiveVideo(video.link)}
                className={`group w-[150px] shrink-0 snap-start overflow-hidden rounded-lg ${isDark?"bg-gray-100":"bg-white"} text-left shadow-sm  transition hover:-translate-y-0.5 hover:shadow-md sm:w-[300px] lg:w-[340px]`}
              >
                <div className="relative group">
                  <img
                    src={thumbnail}
                    alt={video.title}
                    loading="lazy"
                    className="h-auto w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-slate-900/30 transition group-hover:bg-slate-900/45" />
                  <span className={`absolute left-1/2 top-1/2 inline-flex md:h-12 h-8 md:w-12 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full ${isDark?"bg-gray-100":"bg-white/90"} text-red-600 shadow`}>
                    <FaPlay size={12} />
                  </span>
                </div>
              </button>
            );
          })}
        </div>

        {activeVideo && getEmbedUrl(activeVideo) && (
          <VideoModal
            url={activeVideo}
            isShort={isYoutubeShort(activeVideo)}
            onClose={() => setActiveVideo(null)}
          />
        )}

      </div>
    </section>
  );
};
export default YoutubePreview;
